module.exports = __webpack_public_path__ + "static/media/traffic-alert-event.ba15a7d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/traffic-alert-event.svg
// module id = 659
// module chunks = 0